import { OrderbookDataItem } from 'store/orderbook/types'
import { precisionForPrice } from './precision'

/**
 * It checks if the price is in the list of orders.
 * @param {OrderbookDataItem[]} list - (GetUserOrdersItem | OrderData)[]
 * @param {string} price - the price of the user order
 * @returns A boolean value
 */
export function isOrderedPrice(
  list: { price: number }[],
  price: string,
  precision: string,
): boolean {
  if (!list?.length) return false

  return list.some(
    (item) => price === precisionForPrice(String(item.price), precision),
  )
}
